<!-- src/components/Home.vue -->

<template>
  <div>
      <header-component />
    <thankYouBannerComponent
        :customer-name="customerName"
        :booking-id="bookingId"
      />
      <footer-component />
  </div>
</template>

<script>
import headerComponent from '../header/headerComponent.vue';
import thankYouBannerComponent from '../thankYou/thankYouBannerComponent.vue';
import footerComponent from '../footer/footerComponent.vue';
import { bookingDataStore } from '@/stores/bookingDataStore';
export default {
  name: 'homeComponent',
  components: {
    headerComponent,
    thankYouBannerComponent,
    footerComponent,
  },
  data() {
    return {
      customerName: bookingDataStore.customerName,
      bookingId: bookingDataStore.bookingId,
    };
  }
};
</script>
